<div *ngFor="let item of data" [class]="getClass(item)" role="alert">
  <div class="flex-grow-1" innerHtml="{{item.content}}">{{item.content}}</div>
  <a *ngIf="item.closable" class="cancel" (click)="close(item)">
    <i class="icon-cancel"></i>
  </a>
</div>
